import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { SectionRoute } from "@/components/shared/SectionRoute";
import { AddNewPatientsInfo } from "@/components/patients/add-new/AddNewPatientsInfo";
import { AddPatientsForm } from "@/components/patients/add-new/form/AddPatientsForm";

export const Route = createFileRoute("/dashboard/patients/new/")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: AddNewPatients,
});

function AddNewPatients() {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <SectionRoute
        route_one={t("routes.dashboard")}
        route_two={t("routes.patients")}
        route_two_link="/dashboard/patients"
        route_three={t("routes.add_patients")}
      />
      <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-12 mb-8 max-w-7xl mx-auto">
        <AddNewPatientsInfo />
        <AddPatientsForm />
      </div>
      <div className="h-14"></div>
    </div>
  );
}
